import { darken, lighten } from '@material-ui/core';
import { isFixAndFlip, isGroundUp } from '@roc/feature-utils';
import {
  DescribedRennovation,
  PURCHASE,
  REFINANCE,
  TOWNHOME,
} from '@roc/feature-utils';
import {
  PPP_3_2_1,
  PPP_4_3_2_1,
  PPP_5_4_3_2_1,
  PPP_YIELD_MAINTENANCE,
} from '@roc/client-portal-shared/utils';

export const EMPTY_FEE_NAME_MESSAGE = 'Please fill in the name for all fees or remove empty fees before continuing.';

const DANGER_COLOR = '#ad4b4b';
const DISABLED_COLOR = '#8B8B8B';
const BEIGE_COLOR = '#E3EAF2';


export const deleteIconButtonStyle = {
  color: DANGER_COLOR,
  borderColor: DANGER_COLOR,
  '&:hover': {
    color: darken(DANGER_COLOR, 0.1),
    borderColor: darken(DANGER_COLOR, 0.1),
  },
  '&.Mui-disabled': {
    color: lighten(DISABLED_COLOR, 0.5),
    borderColor: lighten(DISABLED_COLOR, 0.5),
  },
};

export const beigeButtonColorStyle = {
  backgroundColor: BEIGE_COLOR,
  boxShadow: '0 2px 1px rgba(0, 0, 0, 0.14)',
  border: `solid 1px ${BEIGE_COLOR}`,
};
const DEFAULT_GROUND_UP_FLOOR_RATE = 10.99;
const DEFAULT_FIX_AND_FLIP_FLOOR_RATE = 9.25;

export const defaultFloorRateBridgeLoans = (loanSubtype: string) => {
  if (isGroundUp(loanSubtype)) {
    return DEFAULT_GROUND_UP_FLOOR_RATE;
  }
  return DEFAULT_FIX_AND_FLIP_FLOOR_RATE;
};
export const deleteButtonStyle = {
  color: DANGER_COLOR,
  borderColor: DANGER_COLOR,
  backgroundColor: lighten(DANGER_COLOR, 0.999),
  '&:hover': {
    color: darken(DANGER_COLOR, 0.1),
    borderColor: darken(DANGER_COLOR, 0.1),
    backgroundColor: lighten(DANGER_COLOR, 0.99),
  },
  '&.Mui-disabled': {
    color: lighten(DISABLED_COLOR, 0.5),
    backgroundColor: lighten(DISABLED_COLOR, 1),
    borderColor: lighten(DISABLED_COLOR, 0.5),
  },
};

export const FORM_MAX_WIDTH = '736px';

export const bridgeExperienceOptions = [
  {
    label: 'No verified properties',
    value: 1
  },
  {
    label: '1 - 2 verified properties',
    value: 2,
  },
  {
    label: '3 - 4 verified properties',
    value: 3,
  },
  {
    label: '5 - 9 verified properties',
    value: 4,
  },
  {
    label: '10 + verified properties',
    value: 5,
  },
];

export const groundUpExperienceOptions = [
  {
    label: 'No Experience',
    value: 1,
  },
  {
    label: '1-2 Ground Up Construction',
    value: 3,
  },
  {
    label: '3-4 Ground Up Construction',
    value: 4,
  },
  {
    label: '5+ Ground Up Construction',
    value: 5,
  },
  {
    label: '20+ Ground Up Construction',
    value: 6,
  },
];
export const rentalExperienceOptions = [
  {
    label: 'No Rental Experience',
    value: 0,
  },
  {
    label: '1-2 Rental Properties',
    value: 1,
  },
  {
    label: '3-4 Rental Properties',
    value: 2,
  },
  {
    label: '5-9 Rental Properties',
    value: 3,
  },
  {
    label: '10-49 Rental Properties',
    value: 4,
  },
  {
    label: '50+ Rental Properties',
    value: 5,
  },
];

export const PROPERTY_TYPE_OTHER = 'Other';

export const propertyTypeOptions = [
  { label: 'Single Family', value: 'Single Family' },
  {
    label: 'Duplex',
    value: 'Duplex',
  },
  {
    label: 'Triplex',
    value: 'Triplex',
  },
  {
    label: 'Quadruplex',
    value: 'Quadruplex',
  },
  {
    label: 'Warrantable Condominium',
    value: 'Condominium',
  },
  { value: 'Townhome', label: 'Townhome' },
  { value: 'Planned Unit Development', label: 'Planned Unit Development' },
  { value: 'Mixed Use', label: 'Mixed Use' },
  { value: '5Plus Unit Multifamily', label: '5+ Unit Multifamily' },
  { value: PROPERTY_TYPE_OTHER, label: PROPERTY_TYPE_OTHER },
];

export const propertyTypeOptionsFnFGU = [
  { label: 'Single Family', value: 'Single Family' },
  {
    label: 'Duplex',
    value: 'Duplex',
  },
  {
    label: 'Triplex',
    value: 'Triplex',
  },
  {
    label: 'Quadruplex',
    value: 'Quadruplex',
  },
  {
    label: 'Warrantable Condominium',
    value: 'Condominium',
  },
  {
    label: TOWNHOME,
    value: TOWNHOME,
  },
  { value: 'Mixed Use', label: 'Mixed Use' },
  { value: '5Plus Unit Multifamily', label: '5+ Unit Multifamily' },
  { value: PROPERTY_TYPE_OTHER, label: PROPERTY_TYPE_OTHER },
];

export const MIXED_USE = 'Mixed Use';
export const MULTIFAMILY_5_PLUS = '5Plus Unit Multifamily';
export const RATE_TERM_REFINANCE = 'Rate Term Refinance';

export const propertySourceValues = {
  bankruptcySale: 'Bankruptcy Sale',
  entityToEntity: 'Entity to Entity',
  estateSale: 'Estate Sale',
  foreclosureAuction: 'Foreclosure Auction',
  inheritance: 'Inheritance',
  multipleListingService: 'Multiple Listing Service',
  onlineAuction: 'Online Auction',
  preForeclosure: 'Pre-Foreclosure',
  privateSale: 'Private Sale',
  realEstateOwned: 'Real Estate Owned',
  sheriffsSale: "Sheriff's Sale",
  shortSale: 'Short Sale',
  wholesaler: 'Wholesaler',
  other: 'Other',
};

export enum PropertySource {
  WHOLESALER = 'Wholesaler',
  OTHER = 'Other',
}

export const propertySourceOptions = [
  {
    label: propertySourceValues.bankruptcySale,
    value: propertySourceValues.bankruptcySale,
  },
  {
    label: propertySourceValues.entityToEntity,
    value: propertySourceValues.entityToEntity,
  },
  {
    label: propertySourceValues.estateSale,
    value: propertySourceValues.estateSale,
  },
  {
    label: propertySourceValues.foreclosureAuction,
    value: propertySourceValues.foreclosureAuction,
  },
  {
    label: propertySourceValues.inheritance,
    value: propertySourceValues.inheritance,
  },
  {
    label: propertySourceValues.multipleListingService,
    value: propertySourceValues.multipleListingService,
  },
  {
    label: propertySourceValues.onlineAuction,
    value: propertySourceValues.onlineAuction,
  },
  {
    label: propertySourceValues.preForeclosure,
    value: propertySourceValues.preForeclosure,
  },
  {
    label: propertySourceValues.privateSale,
    value: propertySourceValues.privateSale,
  },
  {
    label: propertySourceValues.realEstateOwned,
    value: propertySourceValues.realEstateOwned,
  },
  {
    label: propertySourceValues.sheriffsSale,
    value: propertySourceValues.sheriffsSale,
  },
  {
    label: propertySourceValues.shortSale,
    value: propertySourceValues.shortSale,
  },
  {
    label: propertySourceValues.wholesaler,
    value: propertySourceValues.wholesaler,
  },
  {
    label: propertySourceValues.other,
    value: propertySourceValues.other,
  },
];

export const describedRennovationOptions = [
  { label: 'No', value: DescribedRennovation.NO },
  {
    label: 'Expanding the square footage (Horizontally)',
    value: DescribedRennovation.HORIZONTAL,
  },
  {
    label: 'Expanding the square footage (Vertically)',
    value: DescribedRennovation.VERTICAL,
  },
  {
    label: 'Expanding the square footage (Horizontally & Vertically)',
    value: DescribedRennovation.VERTICAL_AND_HORIZONTAL,
  },
  { label: 'Changing the unit count', value: DescribedRennovation.UNIT_COUNT },
  {
    label: 'Converting to Condominiums',
    value: DescribedRennovation.CONDO_CONVERSION,
  },
  {
    label: 'Adding or converting to an ADU (Accessory Dwelling Unit)',
    value: DescribedRennovation.ADU_CONVERSION,
  },
  { label: 'Repairing fire damage', value: DescribedRennovation.FIRE_DAMAGE },
];

export enum SquareFootageExpansion {
  NO = 'NO',
  VERTICAL = 'VERTICAL',
  HORIZONTAL = 'HORIZONTAL',
  VERTICAL_AND_HORIZONTAL = 'VERTICAL_AND_HORIZONTAL',
}

export const squareFootageExpansionOptions = [
  { label: 'No', value: SquareFootageExpansion.NO },
  { label: 'Yes, Vertical Expansion', value: SquareFootageExpansion.VERTICAL },
  {
    label: 'Yes, Horizontal Expansion',
    value: SquareFootageExpansion.HORIZONTAL,
  },
  {
    label: 'Yes, Vertical & Horizontal Expansion',
    value: SquareFootageExpansion.VERTICAL_AND_HORIZONTAL,
  },
];


export enum QuoteStep {
  ENTITY_INFORMATION = 'ENTITY_INFORMATION',
  BORROWER_INFORMATION = 'BORROWER_INFORMATION',
  PROPERTY_INFORMATION = 'PROPERTY_INFORMATION',
  PORTFOLIO_INFORMATION = 'PORTFOLIO_INFORMATION',
  LEVERAGE = 'LEVERAGE',
  LOAN_ECONOMICS = 'LOAN_ECONOMICS',
  LOAN_PRICER = 'LOAN_PRICER',
  SUMMARY = 'SUMMARY',
  PREFLIGHT = 'PREFLIGHT',
  FINAL_DETAILS = 'FINAL_DETAILS',
  SUCCESS = 'SUCCESS',
}


export const bridgeQuoteSteps = [
  QuoteStep.ENTITY_INFORMATION,
  QuoteStep.BORROWER_INFORMATION,
  QuoteStep.PROPERTY_INFORMATION,
  QuoteStep.LEVERAGE,
  QuoteStep.LOAN_ECONOMICS,
  QuoteStep.SUMMARY,
  QuoteStep.FINAL_DETAILS,
  QuoteStep.SUCCESS,
];

export const rentalQuoteSteps = [
  QuoteStep.ENTITY_INFORMATION,
  QuoteStep.BORROWER_INFORMATION,
  QuoteStep.PROPERTY_INFORMATION,
  QuoteStep.LOAN_PRICER,
  QuoteStep.SUMMARY,
  QuoteStep.FINAL_DETAILS,
  QuoteStep.SUCCESS,
];

export const rentalPortfolioQuoteSteps = [
  QuoteStep.ENTITY_INFORMATION,
  QuoteStep.BORROWER_INFORMATION,
  QuoteStep.PORTFOLIO_INFORMATION,
  QuoteStep.LOAN_PRICER,
  QuoteStep.SUMMARY,
  QuoteStep.FINAL_DETAILS,
  QuoteStep.SUCCESS,
];


export enum InterestAccrualMethod {
  FULL_BOAT = 'Full Boat',
  AS_DISBURSED = 'As disbursed',
  INTEREST_ONLY = 'Interest Only',
}

export const interestAccrualMethodOptions = [
  { label: InterestAccrualMethod.FULL_BOAT, value: InterestAccrualMethod.FULL_BOAT },
  { label: InterestAccrualMethod.AS_DISBURSED, value: InterestAccrualMethod.AS_DISBURSED },
]

export const propertyOwnershipOptions = [
  { label: 'Yes', value: REFINANCE },
  { label: 'No', value: PURCHASE },
];

export enum SelectEntityOption {
  SEARCH_ENTITY = 'SEARCH_ENTITY',
  ADD_ENTITY = 'ADD_ENTITY',
  NO_ENTITY = 'NO_ENTITY',
}

export const SOFT_COSTS_TOOLTIP = `Soft costs are all the expenses that aren't directly tied to the
physical building work but are needed to plan, approve, and
manage the project, like permits, architectural, and
engineering fees.`;


export enum FeeNames {
  INTEREST_RESERVE = 'Interest Reserve',
  THIRD_PARTY_FEES = 'Third Party Fees',
  ORIGINATION_POINTS = 'Origination Points',
}

export enum LoanSubType {
  FIX_AND_FLIP = 'Fix and Flip (1-4)',
  FIX_AND_FLIP_PRO = 'Fix and Flip Pro (1-4)',
  GROUND_UP = 'Groundup (1-4)',
  MULTIFAMILY_BRIDGE_5PLUS = 'Multifamily Bridge (5+)',
  SINGLE_PROPERTY = 'Single Property Rental',
  SINGLE_PROPERTY_MULTIFAMILY = 'Single Property Multifamily Term',
  SINGLE_PROPERTY_MIXED_USE = 'Single Property Mixed Use',
  RENTAL_PORTFOLIO = 'Rental Portfolios',
  MULTIFAMILY_TERM_PORTFOLIO = 'Multifamily Term Portfolios',
  MIXED_USE_PORTFOLIO = 'Mixed Use Portfolios',
  STABILIZED_BRIDGE = 'Stabilized Bridge',
  OTHER_BRIDGE = 'Other Bridge',
  OTHER_RENTAL = 'Other Rental',
}

export enum AmortizationType {
  FULLY_AMORTIZING = 'fullyAmortizing',
  PARTIAL_INTEREST_ONLY = 'partialInterest',
}

export const amortizationOptions = [
  { label: 'Fully Amortizing', value: AmortizationType.FULLY_AMORTIZING },
  { label: 'Partial Interest Only ', value: AmortizationType.PARTIAL_INTEREST_ONLY },
];

export enum RateTypeOptions {
  FIVE_SIX_ARM = '5/6 ARM',
  SEVEN_SIX_ARM = '7/6 ARM',
  TEN_SIX_ARM = '10/6 ARM',
  THIRTY_YEAR_FRM = '30 Yr FRM',
}

export enum PPPOptions {
  THREE_ZERO_ZERO = '3-0-0',
  ONE_ZERO_ZERO = '1-0-0',
  THREE_TWO_ZERO = '3-2-0',
}

export const rateTypeOptions = [
  {
    label: '5/6 ARM',
    value: RateTypeOptions.FIVE_SIX_ARM,
  },
  {
    label: '7/6 ARM',
    value: RateTypeOptions.SEVEN_SIX_ARM,
  },
  {
    label: '10/6 ARM',
    value: RateTypeOptions.TEN_SIX_ARM,
  },
  {
    label: '30 Yr FRM',
    value: RateTypeOptions.THIRTY_YEAR_FRM,
  },
];

export const prepaymentPenaltyOptions = [
  {
    label: 'Yield Maintenance',
    value: PPP_YIELD_MAINTENANCE,
  },
  {
    label: '3-2-1 Prepay',
    value: PPP_3_2_1,
  },
  {
    label: '4-3-2-1 Prepay',
    value: PPP_4_3_2_1,
  },
  {
    label: '5-4-3-2-1 Prepay',
    value: PPP_5_4_3_2_1,
  },
  {
    label: '3-2-0 Prepay',
    value: PPPOptions.THREE_TWO_ZERO,
  },
  {
    label: '3-0-0 Prepay',
    value: PPPOptions.THREE_ZERO_ZERO,
  },
  {
    label: '1-0-0 Prepay',
    value: PPPOptions.ONE_ZERO_ZERO,
  },
];

export const AMORTIZED_DURATION = 360;

export enum LeveragePricingType {
  LTC = 'ltc',
  LTV = 'ltv',
}
